<template>
  <div class="wrapper">
    <parallax
      class="section page-header header-filter"
      :style="headerStyle"
    ></parallax>
    <div class="main main-raised">
      <div class="section profile-content">
        <div class="container">
          <div class="md-layout">
            <div class="md-layout-item md-size-50 mx-auto">
              <div class="profile">
                <div class="avatar">
                  <img
                    :src="img"
                    alt="Circle Image"
                    class="img-raised rounded img-fluid"
                    style="background: white;"
                  />
                </div>
                <div class="name">
                  <h3 class="title">Clústeres</h3>

                </div>
              </div>
            </div>
          </div>
    <div class="title">
      <h3>Ometéotl</h3>
    </div>
    <div class="md-layout">
      <div class="md-layout-item md-size-50 md-small-size-100">
        <img
                src="@/assets/img/ometeotl.png"
                alt="Ometeotl"
                class="img-raised  img-fluid"
        />

      </div>

      <div class="md-layout-item md-size-50 md-small-size-100">
        Componentes
        <ul>
          <li>40 Nodos Supermicro con procesadores Xeon V3, V4, Gold</li>

          <li>1360 Cores</li>

          <li> 7520 Gb Memoria RAM</li>
          <li> 218 Tb </li>
          <li>CentOS  6.10</li>
          <li>Lustre  2.8.0-RC5	</li>
          <li>Slurm 17.02 </li>


        </ul>

        Aplicaciones
        <ul>
          <li> WRF, WRF-Chem, NCView, Mathlab, HYCOM, WWIII, FALL3D</li>

        </ul>
        Herramientas de Desarrollo
        <ul>
          <li>Intel parallel studio xe2017, Intel parallel studio xe 2019, PGI 18.7, IDL 2017,Python 2.6</li>


        </ul>   </div>
    </div>

    <div class="title">
      <h3>Tláloc</h3>
    </div>
    <div class="md-layout">
      <div class="md-layout-item md-size-50 md-small-size-100 ">

        Componentes
        <ul>
          <li>11 Nodos Supermicro con procesadores Xeon V3, V4, Gold</li>

          <li>272 Cores</li>

          <li> 800 Gb Memoria RAM</li>
          <li>14 Tb </li>
          <li>CentOS  6.10</li>
          <li>Lustre  2.8.0-RC5	</li>
          <li>Slurm 19.05 </li>


        </ul>

         Aplicaciones
          <ul>
          <li> WRF, WRF-Chem, NCView, Matlab, R </li>

          </ul>
          Herramientas de Desarrollo
            <ul>
           <li>Intel parallel Studio XE 2018u4 2019u4, NCL 6.6.2, Python 2.6 3.7</li>


          </ul>


      </div>
      <div class="md-layout-item md-size-50 md-small-size-100">
        <img
                src="@/assets/img/tlaloc.jpg"
                alt="Ometeotl"
                class="img-raised   img-fluid"
        />

      </div>

    </div>


     <div class="title">
      <h3>Poseidón</h3>
    </div>
    <div class="md-layout">

      <div class="md-layout-item md-size-50 md-small-size-100">
        <img
                src="@/assets/img/tlaloc.jpg"
                alt="Ometeotl"
                class="img-raised   img-fluid"
        />

      </div>

      <div class="md-layout-item md-size-50 md-small-size-100 ">

        Componentes
        <ul>
          <li>20 Nodos Supermicro con procesadores Xeon V3, V4, Gold</li>

          <li>352 Cores</li>

          <li> 1024 Gb Memoria RAM</li>
          <li> 80 Tb </li>
          <li>CentOS  6.10</li>
          <li>NFS	</li>
          <li>Slurm 19.05 </li>


        </ul>

         Aplicaciones
          <ul>
          <li>WRF, Cosmo, R </li>

          </ul>
          Herramientas de Desarrollo
            <ul>
           <li> Intel parallel studio xe 2018u4 2019u4, NCL 6.6.2, Python 2.6 3.7</li>


          </ul>


      </div>


    </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Tabs } from "@/components";
export default {
  components: {
   
  },
  bodyClass: "profile-page",
  data() {

  },
  props: {
    header: {
      type: String,
      default: require("@/assets/img/vue-mk-header.jpg")
    },
    img: {
      type: String,
      default: require("@/assets/img/process.png")
    }
  },
  computed: {
    headerStyle() {
      return {
        backgroundImage: `url(${this.header})`
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.section {
  padding: 0;
}
</style>
